import FeatSDKV3 from 'api/version3';
import { createEffect } from 'effector';
import { PaymentType } from 'models';
import { Order, User } from '../entities';
import { mapOrderToPaymentTypesRequest } from '../model/mapOrderToPaymentTypesRequest';

export const getRetryPaymentTypesFx = createEffect(
  async ({
    order,
    user,
  }: {
    order: Order;
    user: User | null;
  }): Promise<PaymentType[]> => {
    const request = mapOrderToPaymentTypesRequest(order, user);

    return user
      ? FeatSDKV3.orders.ordersAvaliablePaymentTypes(request)
      : FeatSDKV3.orders.notSecureOrdersAvaliablePaymentTypes(request);
  },
);
